import { Col, Container, Row } from "react-bootstrap"
import { useParams } from "react-router"
import { useGetBookingRequestByIdQuery } from "../../../services/bClientApi"

export default function BookingRequestPage() {
  const { bookingRequestId = '' } = useParams()

  const {
    data: bookingRequestData,
    error,
    // isLoading,
  } = useGetBookingRequestByIdQuery(bookingRequestId, { skip: !bookingRequestId })

  return (
    <Container>
      <Row>
        <Col>
          <h1>Single Booking Request Page</h1>
          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          {bookingRequestId && bookingRequestData && (
            <div className="booking-requestinfo">
              <pre>
                {JSON.stringify(bookingRequestData, null, 2)}
              </pre>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  )
}
